export const tomSelectRender = {
  no_results: (data, escape) => `<div class="no-results">${escape(window.I18n?.keine_treffer ?? "Keine Treffer gefunden")}</div>`,
}
